import { render, staticRenderFns } from "./AccountsDatatable.vue?vue&type=template&id=07245b6f&scoped=true&"
import script from "./AccountsDatatable.vue?vue&type=script&lang=js&"
export * from "./AccountsDatatable.vue?vue&type=script&lang=js&"
import style0 from "./AccountsDatatable.vue?vue&type=style&index=0&id=07245b6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07245b6f",
  null
  
)

export default component.exports